import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Feedback = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16.0001 2C8.2805 2 2.00013 8.28038 2.00013 16C2.00013 18.8477 2.84025 21.5634 4.43563 23.8929L2.10625 28.5534C2.03888 28.6879 2 28.8392 2 29C2 29.5523 2.44775 30 3 30C3.16075 30 3.312 29.9611 3.44663 29.8937L8.10713 27.5644C10.4368 29.1599 13.1524 29.9999 16 29.9999C23.7196 29.9999 30 23.7195 30 15.9999C30 8.28025 23.7198 2 16.0001 2ZM16.0001 28C13.3795 28 10.8898 27.1702 8.80025 25.6007C8.62363 25.4681 8.41225 25.4002 8.1995 25.4002C8.04713 25.4002 7.89388 25.435 7.75238 25.5059L5.23613 26.7639L6.49425 24.2476C6.66375 23.9085 6.627 23.5028 6.39938 23.1996C4.82975 21.1104 4.00013 18.6207 4.00013 15.9999C4.00013 9.383 9.38325 3.99988 16.0001 3.99988C22.617 3.99988 28.0001 9.383 28.0001 15.9999C28.0001 22.6168 22.617 27.9999 16.0001 27.9999V28Z" />
		<path d="M24 17C24 16.4477 23.5523 16 23 16C22.6123 16 22.2767 16.2211 22.1109 16.5438C22.11 16.5454 22.1086 16.5468 22.1077 16.5485C22.0355 16.6894 20.2899 20 16 20C11.7101 20 9.97212 16.704 9.89275 16.5495C9.89187 16.5476 9.89037 16.5463 9.8895 16.5445C9.72375 16.2215 9.388 16.0001 9 16.0001C8.44775 16.0001 8 16.4479 8 17.0001C8 17.1579 8.0375 17.3066 8.10262 17.4393C8.10387 17.4419 8.10425 17.4447 8.10563 17.4474C8.19863 17.6331 10.4459 22.0001 16 22.0001C21.5541 22.0001 23.8015 17.6331 23.8944 17.4474C23.8956 17.4447 23.8961 17.442 23.8974 17.4394C23.9625 17.3066 24 17.158 24 17.0001V17Z" />
	</svg>
);

export default Feedback;
